module.exports = __webpack_public_path__ + "ea5f49db038e577213470eb3d0b6df44.svg";